/**
 * The platform's state list is closed and an address source can answer with a code
 * outside it — military mail is `AA`, `AE` or `AP` — so an unmapped code must not
 * be written where the save would refuse it. An empty list accepts: a form whose
 * options have not arrived cannot refuse anything.
 *
 * What each caller does with a refusal differs on purpose — the ZIP path leaves
 * State alone and names the code, the address path clears it.
 */
const acceptState = (
  state: string | null | undefined,
  knownStates: string[] = []
) => !knownStates.length || (!!state && knownStates.includes(state))

export { acceptState }
